import { apiClient } from '@/api/client'
import type { ApiSuccessResponse } from '@/types/api'

export interface DashboardTrend {
  current: number    // last 30 days
  previous: number   // the 30 days before that
}

export interface DashboardMonthPoint {
  month: string        // 'YYYY-MM'
  applications: number
  hirings: number
}

export interface AdminDashboardData {
  totals: {
    students: number
    recruiters: number
    organizations: number
    jobs: number
    applications: number
    hirings: number
  }
  trends: {
    organizations: DashboardTrend
    jobs: DashboardTrend
    applications: DashboardTrend
    hirings: DashboardTrend
  }
  placement: { applied: number; hired: number; ratePercent: number }
  activeEmployers: { active: number; approved: number }
  openPositions: { openings: number; filled: number; remaining: number }
  hiringFunnel: DashboardFunnelStage[]
  skillsDemandSupply: DashboardSkillRow[]
  topEmployers: DashboardEmployerRow[]
  programPerformance: DashboardProgramRow[]
  recentHires: DashboardRecentHire[]
  monthlyChart: DashboardMonthPoint[]
}

export interface DashboardFunnelStage {
  stage: 'applied' | 'under_review' | 'shortlisted' | 'hired'
  count: number
}

export interface DashboardSkillRow {
  skill: string
  demand: number   // published jobs asking for the skill
  supply: number   // candidates listing the skill
}

export interface DashboardEmployerRow {
  id: number
  name: string
  status: string
  jobs: number
  applications: number
  hires: number
}

export interface DashboardProgramRow {
  program: string
  phase: string | null
  isPortal: boolean
  students: number
  applied: number
  shortlisted: number
  hired: number
}

export interface DashboardRecentHire {
  applicationId: number
  candidate: string | null
  jobTitle: string
  organization: string
  hiredAt: string
}

export const adminDashboardApi = {
  get: async (): Promise<AdminDashboardData> => {
    const { data } = await apiClient.get<ApiSuccessResponse<AdminDashboardData>>('/admin/dashboard')
    return data.data
  },
}
